import React from 'react';
import styles from './index.module.scss';

const TermsPopupComponent = ({ onAgree, onDisagree, onRulesClick }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} />
      <div className={styles.sheet}>
        <div className={styles.textBlock}>
          <p className={styles.title}>Умови та положення</p>
          <p className={styles.description}>
            Для подальшого користування сервісом Ви маєте погодитись з{' '}
            <span className={styles.link} onClick={onRulesClick}>
              правилами програми
            </span>{' '}
            і{' '}
            <span
              className={styles.link}
              onClick={() =>
                window.open(
                  'https://www.pmiprivacy.com/ukraine/uk/consumer/',
                  '_blank'
                )
              }
            >
              політикою конфіденційності.
            </span>
          </p>
        </div>
        <div className={styles.buttons}>
          <button className={styles.agreeButton} onClick={onAgree}>
            Погоджуюсь
          </button>
          <button className={styles.disagreeButton} onClick={onDisagree}>
            Не погоджуюсь
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsPopupComponent;
